import { useLocalObservable } from "mobx-react";
import React, { createContext, ReactNode } from "react";
import RegistryStore from "./registryStore";

interface RegistryProviderProps {
  children: ReactNode;
}

export const RegistryContext = createContext<RegistryStore | null>(null);
RegistryContext.displayName = "RegistryContext";

export const RegistryProvider = ({ children }: RegistryProviderProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const store = useLocalObservable(() => new RegistryStore());

  return <RegistryContext.Provider value={store}>{children}</RegistryContext.Provider>;
};
